import Add from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import {
  useConfigModeContext,
  useFormConfigContext,
} from "./ConfigFormContext";

const ConfigNoValidation: React.FC = () => {
  const { setValue } = useFormConfigContext();
  const { isReadOnly } = useConfigModeContext();

  return (
    <>
      <Typography className="italic">
        Une validation permet d'évaluer certaines règles sur les résultats de
        votre traitement.
        <br />
        Cela peut vous permettre de vérifier l'exactitude ou la cohérence des
        données extraites.
      </Typography>
      <div className="flex justify-center">
        {!isReadOnly && (
          <Button
            variant="contained"
            onClick={() =>
              setValue("config.validation", {
                asset_rules: [],
                document_rules: [],
              })
            }
            className="gap-2"
          >
            <Add />
            Validation
          </Button>
        )}
      </div>
    </>
  );
};
export default ConfigNoValidation;
